import { makeStyles } from "@material-ui/core";
import { useCollection, useIO } from "@type-r/react";
import { div, Flex, Loading, Page, TilesList, Columns } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { RowH1 } from "../../../../../common/inmatch";
import { PolicyCardBase } from "../api/policyCardBase";
import { PolicyCardBound } from "../api/policyCardBound";
import { PolicyCardDraft } from "../api/policyCardDraft";
import { InsurancePoliciesCardRenderer } from "./list-policies";
import { TilesListColumn } from "../components/item-card-styles";

export const InsurancePoliciesPage = () => {
  var classes = useStyles();
  const policyCardsBound = useCollection.of(PolicyCardBound);
  const policyCardsDraft = useCollection.of(PolicyCardDraft);

const isReady = useIO(async () => {
  await Promise.all([
    await policyCardsBound.fetch().catch(e => console.error(e)),
    await policyCardsDraft.fetch().catch(e => console.error(e)),
  ])
})

const sorted = useMemo(() => {
  let allPolicyCards : PolicyCardBase[] = [];
  allPolicyCards = allPolicyCards.concat(policyCardsBound.models).concat(policyCardsDraft.models);
  return allPolicyCards.sort((a: PolicyCardBase, b: PolicyCardBase) => {
    let date1 = a.attributes.inceptionDate;
    let date2 = b.attributes.inceptionDate;
    return  date1 == date2 ? 0 : (date1 > date2 ? -1 : 1);
  })
}, [
  policyCardsBound[ '_changeToken' ],
  policyCardsDraft[ '_changeToken' ]
]);

  return isReady ? <> 
      <Page maxWidth={ false } header={
          <Flex center>
            <RowH1 className={ classes.title }>Insurance Policies</RowH1>
          </Flex>
        }>         
      <Columns style={{ height: 'calc(100% - 80px)' }}>
        <TilesListColumn>
          <TilesList
            items={ sorted }
            itemSize={ 90 }
            renderer={ InsurancePoliciesCardRenderer() }
          />
        </TilesListColumn>
      </Columns>
        </Page> 
        </> : <Loading />

};
const useStyles = makeStyles({
    title: {
      padding: '20px 0',
      color: '#3d6889',
      fontSize: '24px'
    }
  });
  export const ResolvePageRouter = () => {

    return 
        <InsurancePoliciesPage />
}
    
const TilesListContainer = div({
  width: '100%'
});
